import { useGetPublicPendudukStatistikPekerjaan } from '@tatatemplate/shared-lib'

export function usePekerjaanStats() {
  return useGetPublicPendudukStatistikPekerjaan({
    query: { queryKey: ['statistik', 'pekerjaan'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
